import React, { useMemo } from 'react';

const BackgroundAnimations = () => {
    // Gold dust particles — reduced delay so they appear quickly
    const particles = useMemo(() => {
        return Array.from({ length: 30 }, (_, i) => ({
            id: i,
            left: `${Math.random() * 100}%`,
            size: 1.5 + Math.random() * 2.5,
            duration: 10 + Math.random() * 15,
            delay: Math.random() * 4,
            opacity: 0.15 + Math.random() * 0.35,
        }));
    }, []);

    // Floating orbs — larger, softer glowing elements
    const orbs = useMemo(() => {
        return Array.from({ length: 5 }, (_, i) => ({
            id: i,
            left: `${15 + Math.random() * 70}%`,
            top: `${10 + Math.random() * 80}%`,
            size: 80 + Math.random() * 200,
            duration: 20 + Math.random() * 15,
            delay: i * 2,
        }));
    }, []);

    return (
        <div className="vault-animations">
            {/* Ambient floating orbs */}
            {orbs.map(o => (
                <div
                    key={`orb-${o.id}`}
                    className="bg-orb"
                    style={{
                        left: o.left,
                        top: o.top,
                        width: `${o.size}px`,
                        height: `${o.size}px`,
                        animationDuration: `${o.duration}s`,
                        animationDelay: `${o.delay}s`,
                    }}
                />
            ))}

            {/* Gold dust particles */}
            {particles.map(p => (
                <div
                    key={p.id}
                    className="gold-particle"
                    style={{
                        left: p.left,
                        width: `${p.size}px`,
                        height: `${p.size}px`,
                        animationDuration: `${p.duration}s`,
                        animationDelay: `${p.delay}s`,
                        '--particle-opacity': p.opacity,
                    }}
                />
            ))}
        </div>
    );
};

export default BackgroundAnimations;
